const baseUrl = 'https://lagrafejournal.com'; // Change this to your backend URL
export default baseUrl;
